(() => {
  if (window.wauCatalogueTracking) return;
  window.wauCatalogueTracking = true;
  document.addEventListener('click', (event) => {
    const link = event.target.closest('a[data-catalogue-action]');
    if (!link) return;
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'catalogue_interaction',
      catalogue_action: link.dataset.catalogueAction,
      catalogue_language: link.dataset.catalogueLanguage,
      catalogue_version: link.dataset.catalogueVersion,
      link_url: link.href,
    });
  });
})();
